import moment from 'moment-timezone';

/**
 * The time zone every routing date and time is shown in, and that the server cuts days in
 * (decisions.md, TD1-10663). Today the browser's; TD1-6729 makes it user-selectable.
 * A plain function for non-React callers (Redux actions), the hook for components.
 */
export function routingTimeZone(): string {
  return moment.tz.guess();
}

export default function useRoutingTimeZone(): string {
  return routingTimeZone();
}
